import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import useCommonCode from '../../../../../hooks/useCommonCode';

function SchoolYearSelectBox({ defaultValue, handleCodeSet }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState({ cdNm: '', cmnCd: '', upCd: '',});
  const { codeList } = useCommonCode("EDU_CURS_CD");

  useEffect(() => {
    if (!defaultValue || !codeList) return;
    setCode(_.find(codeList, (o) => o.cmnCd === defaultValue));
  }, [defaultValue, codeList]);
  
  const handleOnOffClick = () => {
    setOpen(!open)
  };

  const handleStepClick = (value) => {
    setCode(value);
    handleOnOffClick();
    handleCodeSet('eduCursCd', value.cmnCd);
  }


  return (
    <div className="area">
      <div
        className={clsx('new-select m_40', open && 'opened')}
      >
        <div
          className={clsx({
            "selected_txt": true,
            "first": !code.cdNm
          })}
          onClick={handleOnOffClick}
        >
          {code.cdNm ? <span>{code.cdNm}</span> : "학년학기"}
        </div>
        <div className="select_option">
          <ul>
            <li>
              <button
                type="button"
                className={!code.cdNm ? "selected" : ''}
                onClick={() => handleStepClick({ cdNm: '', cmnCd: '', upCd: '',})}
              >
                학년학기
              </button>
            </li>
            {
              codeList && (
                codeList.map((item) => (
                  <li key={item.cmnCd}>
                    <button
                      type="button"
                      className={code.cmnCd === item.cmnCd ? "selected" : ''}
                      onClick={() => handleStepClick(item)}
                    >
                      {item.cdNm}
                    </button>
                  </li>
                ))
              )
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SchoolYearSelectBox;